import React, { useState } from 'react';
import {Wrapper, Nav, Map} from "./index.styled";
import { MapItemsCategories, MapNav, NavItemsList } from '../map/index.styled';
import mapShop from '../row/map-items/map-shop.json';
import mapDine from '../row/map-items/map-dine.json';
import mapPlay from '../row/map-items/map-play.json';
import mapWork from '../row/map-items/map-work.json';

const Row = () => {
  const [selectedMapItem, setSelectedMapItem] = useState(null);
  const [selectedMapCategory, setSelectedMapCategory] = useState(mapShop);

  const AlphabeticalSort = () => {
    selectedMapCategory.features.sort((a, b) => {
      let nameA = a.properties.NAME.toLowerCase();
      let nameB = b.properties.NAME.toLowerCase();
      if (nameA < nameB) //sort string ascending
        return -1;
      if (nameA > nameB)
        return 1;
      return 0; //default return value (no sorting)
    })
  }
  AlphabeticalSort()
  const setCategoryActive = (cat) => {
    setSelectedMapCategory(cat);
  };

  return (
    <Wrapper>
      <Nav>
        <MapItemsCategories>
          <ul>
            <li>
            <span onClick={() => {
              setCategoryActive(mapShop);
              setSelectedMapItem(null);
            }}>
              Shop
            </span>
              {selectedMapCategory.name === "shop" &&
              <NavItemsList className={selectedMapCategory.name}>
                {selectedMapCategory.features.map((item, i) => {
                  return (
                    <p data-id={i+1} key={item.properties.NAME}>
                      {item.properties.NAME}
                    </p>
                  );
                })
                }
              </NavItemsList>
              }
            </li>


            <li>
            <span onClick={() => {
              setCategoryActive(mapDine);
              setSelectedMapItem(null);
            }}>Dine</span>
              {selectedMapCategory.name === "dine" &&
              <NavItemsList className={selectedMapCategory.name}>
                {selectedMapCategory.features.map((item, i) => {
                  return (
                    <p data-id={i+1} key={item.properties.NAME}>
                      {item.properties.NAME}
                    </p>
                  );
                })
                }
              </NavItemsList>
              }
            </li>

            <li>
            <span onClick={() => {
              setCategoryActive(mapPlay);
              setSelectedMapItem(null);
            }}>Play</span>
              {selectedMapCategory.name === "play" &&
              <NavItemsList className={selectedMapCategory.name}>
                {selectedMapCategory.features.map((item, i) => {
                  return (
                    <p data-id={i+1} key={item.properties.NAME}>
                      {item.properties.NAME}
                    </p>
                  );
                })}
              </NavItemsList>
              }
            </li>

            <li>
            <span onClick={() => {
              setCategoryActive(mapWork);
              setSelectedMapItem(null);
            }}>Work</span>
              {selectedMapCategory.name === "work" &&
              <NavItemsList className={selectedMapCategory.name}>
                {selectedMapCategory.features.map((item, i) => {
                  return (
                    <p data-id={i+1} key={item.properties.NAME}>
                      {item.properties.NAME}
                    </p>
                  );
                })}
              </NavItemsList>
              }
            </li>
          </ul>
        </MapItemsCategories>

      </Nav>

      <Map>
        <img className="center" src="/images/pages/maps/rowMap.jpg" alt="Row primary map" />
      </Map>
    </Wrapper>
  )
}

export default Row;
